import React, { useState, useEffect, useCallback, useMemo } from 'react'

import JobUploader from './Uploader'
import JobCard from './Card'
import api from '../../../api'
import { Job, getJobId } from '../../../data/job'
import { useUserMeta } from '../../../hooks/useUserMeta'
import { freeTrialRemaining } from '../../../data/user'
import { Link } from 'react-router-dom'
import useTitle from '../../../hooks/useTitle'

const Jobs: React.FC = () => {
  useTitle("Transcription | Speech2")

  const userMeta = useUserMeta()

  // Used to reload jobs
  const [ v, setV ] = useState<number>(0)

  const [ jobs, setJobs ] = useState<Job[]>([])

  const reloadJobs = useCallback(
    () => {
      setV(v => v + 1)
    },
    [ setV ]
  )

  useEffect(() => {
    (async () => {
      const resp = await api.jobs.list()
      if (resp.data.error !== true) {
        setJobs(resp.data.data)
      }
    })()
  }, [ setJobs, v ])

  const canUploadJobs = useMemo(
    () => {
      if (!userMeta)
        return true

      const remainingSecs = freeTrialRemaining(userMeta)
      if (remainingSecs > 0 || userMeta.card_registered === true) {
        return true
      }
      return false
    },
    [ userMeta ]
  )

  useEffect(() => {
    if ( jobs.filter(j => j.error !== true && !j.finished_at ).length >= 1 ) {
      // there are jobs in flight
      let timer: number
      const runRefresh = () => {
        reloadJobs()
        timer = window.setTimeout(runRefresh, 10_000)
      }
      timer = window.setTimeout(runRefresh, 10_000)

      return () => {
        if (timer) window.clearTimeout(timer)
      }
    }
  }, [ jobs, reloadJobs ])

  return (
    <div className="container">
      <h1 className="my-4">Transcription Jobs</h1>

      { canUploadJobs ?
        <JobUploader
          reloadJobs={reloadJobs}
        />
        :
        <div className="alert alert-danger" role="alert">
          Your free trial has expired. Please <Link to="/billing" className="alert-link">register a credit card</Link> to continue transcribing with us.
        </div>
      }

      <div className="row my-4">
        { jobs.map((job) => <JobCard job={job} key={getJobId(job)} />) }
      </div>
    </div>
  )
}

export default Jobs
